<template>
  <div class="w-full mt-20 px-2">
    <email-verify-form></email-verify-form>

    <portal to="breadcrumb-portal">
      <breadcrumbs>
        <router-link class="breadcrumb-link" :to="{name: 'channels.index'}">Home</router-link>
        <chevron-right-icon class="mx-1"></chevron-right-icon>
        <span class="breadcrumb-current">Verify Your Email</span>
      </breadcrumbs>
    </portal>
  </div>
</template>

<script>
import EmailVerifyForm from "@/components/Forms/EmailVerifyForm"
import { ChevronRightIcon } from "vue-feather-icons"

export default {
  name: "EmailVerify",
  components: {
    EmailVerifyForm,
    ChevronRightIcon
  }
}
</script>

<style lang="scss" scoped>
</style>
